import React, {FC} from 'react'
import CountUp from 'react-countup'
import {shallowEqual, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {IWorkspaceState} from '../../../../app/@reducer/WorkspaceRedux'

type Props = {
    bg: 0 | 1
    countUp: number
    title: string
}

const Card3: FC<Props> = ({bg, countUp, title}) => {

    const {
        colors: {
            primary,
            secondary,
            textColor,
        },
    } = useSelector<RootState>(({workspace}) => workspace, shallowEqual) as IWorkspaceState

    const backgroundColor = bg ? secondary : primary

    return (
        <div className="card card-flush user-select-none h-100" style={{backgroundColor: `${backgroundColor}e6`}}>
            <div className="card-body d-flex flex-column justify-content-between p-5" style={{color: textColor}}>
            <span className="fs-2 fw-bold me-2 lh-1 ls-n2">
                <CountUp end={countUp > 0 ? countUp : 0} duration={1.5} />
            </span>
                <span className="pt-1 fw-semibold fs-7">{title}</span>
            </div>
        </div>
    )
}

export {Card3}
